<template>
    <div class="page-pdpa">
        <LoadingSSO :isShow="loading" />
        <div class="header-container">
            <div class="header-inner">
                <div class="header-wrapper">
                    <img src="@/assets/icon/nestle-header@3x.png" alt="img-head">
                </div>
            </div>
        </div>
        <div class="content-wrapper" v-if="this.isLoaded">
            <div class="content-header">
                <div class="header-wrapper">
                    <div 
                        id="pdpa-switchtab-btn"
                        class="tab-title" 
                        :class="{'active' : activeTab === 'TermCondition'}"
                        @click="switchTab('TermCondition')"
                    >
                        <p>เงื่อนไขและข้อกำหนด</p>
                    </div>
                    <div 
                        class="tab-title"  
                        :class="{'active' : activeTab === 'PrivacyPolicy'}"
                        @click="switchTab('PrivacyPolicy')"
                    >
                        <p>นโยบายความเป็นส่วนตัว</p>
                    </div>
                </div>     
            </div>
            <div class="content-main">
                <div class="desc-container" v-if="activeTab === 'TermCondition'">
                    <Term/>
                </div>
                <div class="desc-container" v-else>
                    <Privacy/>
                </div>
            </div>
        </div>
        <div class="wrapper-btn">
            <div 
                id="pdpa-next-btn"
                v-if="(activeTab === 'TermCondition' && term) || (activeTab === 'PrivacyPolicy' && privacy)" 
                class="btn-submit" @click="clickNext()"
            >
                ตกลง
            </div>
            <div
                id="pdpa-confirm-btn"
                v-else
                class="btn-submit" @click="clickConfirm()"
            >
                ตกลง
            </div>
        </div>
    </div>
</template>

<script>
//component
import Term from "@/module/Pdpapage/component/TermDetail.vue";
import Privacy from "@/module/Pdpapage/component/PrivacyDetail.vue";
import LoadingSSO from "@/components/LoadingSSO/Loading.vue";

export default {
    name: "Pdpa",
    components: {
        Term,
        Privacy,
        LoadingSSO
    },
    props:['data'],
    data: 
        function() {
        return {
            loading: false,
            isLoaded: true,
            activeTab: "TermCondition",
            isFirstTime: true,
            term: false,
            privacy: false
        };
    },
    created: function() {
        document.body.classList.add('body-sso');
        this.loading = true
        this.setTab();
    },
    mounted: function() {

    },
    methods: {
        setTab: function() {
            if(this.$route.params.tab === "privacy") {
                this.activeTab = "PrivacyPolicy"
            } 
            this.loading = false
        },
        switchTab: function(tabName) {
            this.loading = true
            this.activeTab = tabName;
            setTimeout(() => {
                this.loading = false
            }, 500);
        },
        clickNext() {
            this.loading = true
            if (this.activeTab === "TermCondition") {
                this.activeTab = "PrivacyPolicy"
            } else {
                this.activeTab = "TermCondition"
            }
            setTimeout(() => {
                this.loading = false
            }, 500);
        },
        clickConfirm() {
            this.loading = true
            if (this.isFirstTime) {
                this.isFirstTime = false;
                if (this.activeTab === "TermCondition") {
                    this.term = true;
                } else {
                    this.privacy = true;
                }
                this.activeTab === "PrivacyPolicy" ? this.activeTab = "TermCondition" : this.activeTab = "PrivacyPolicy";
                
                setTimeout(() => {
                    this.loading = false
                }, 500);
            } else {
                if (this.data && this.data.data !== null) {
                    this.$router.push({
                        name: "register",
                        params: { data: this.data },
                    })
                } else {
                    this.$router.push("/sso");
                }
            }
        }
    }
};
</script>
<style lang="scss">
.body-sso{
    background: #fff;
}
</style>
<style lang="scss" scoped>
@import "@/style/sso.scss";
</style>
